<template>
    <div>
    <van-nav-bar title="工银信用卡账户安全险" left-arrow @click-left="onClickLeft" />
        <img src="@/assets/images/safeins.jpg">
    </div>
</template>

<script>
export default {
    name:"safeins",

    created(){
        let title = "工银信用卡账户安全险";
        if (this.$getUA() === 1) {
          this.$callApp("Android", "onJSAppSetTitle", title); //调用安卓的设置标题方法
          this.$callApp("Android", "SetWebViewZoom", true)
        }else if (this.$getUA() === 2){
          this.$callApp("iOS", "getWebViewTitleMethod", title); //调用IOS设置标题的方法
          this.$callApp("iOS", "EnableWebZoomMethod", true)
        }
    },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
  },
}
</script>

<style scoped>
img {
    width: 100%;
    height: auto;
  margin-bottom: -3.5px;
}
</style>
